import { lazy } from "react";
import { MY_PROFILE_PATH, PageConfig, PROJECTS } from "../configure/PathConfig";
import { Navigate, useLocation, useParams } from "react-router-dom";

// const playground = 'playground';
const playground = 'playground';
// const dealreview = 'dealreview';
const dealreview = 'deal-review';
// const legal = 'legal';
const legal = 'legal';
const rm = 'new_RM';
const project = 'project';
// Overview

const LazyPlaygroundProjects = lazy(() =>
	import(`../features/${playground}/projects/index`)
);

// Scoped Deals

// const LazyPreliminaryStaffingOverview = lazy(()=> import("../features/scoped/pages/new-completed"));

// const LazyPreliminaryStaffingDashboard = lazy(() =>
// 	import("../features/scoped/pages/dashboard")
// );
// const LazyPreliminaryStaffingReview = lazy(() =>
// 	import("../features/scoped/pages/in-progress")   // Also used in Overview
// );

// INAB

const INAB = 'INABTailwind';

const LazyINABDashboard = lazy(() => 
	import(`@features/inab/index`)
);
const LazyINABNewSubmission = lazy(() => 
	import(`@features/inab/pages/ReviewAndApproval`)
);
const LazyINABReviewAndApproval = lazy(() => 
	import(`@features/inab/pages/ReviewAndApproval`)  // Also used in Overview
);
const LazyINABSubmitForRm = lazy(() => 
	import(`@features/inab/pages/ReviewAndApproval`)   // Also used in RM - Projects
);

// Deal Review

const LazyOverviewNewDeal = lazy(() =>
	import(`../features/${dealreview}/pages/new`) // Also used in Overview
);
const LazyDrDashboard = lazy(() =>
	import(`../features/${dealreview}/pages/dashboard`)
);
const LazyReviewAndApproval = lazy(() =>
	import(`../features/${dealreview}/pages/review-and-approval`)  // Also used in Overview
);

const LazyCompleteAndDealLost = lazy(() =>
	import(`../features/${dealreview}/pages/complete-and-deal-lost`)  // Also used in Overview
);
// const LazyLegalQuestionnaire = lazy(() =>
// 	import("../screens/legal/LegalQuestionnaire/LegalQuestionnaire")  // Also used in Overview
// );
const LazyLegalQuestionnaire = lazy(() =>
	import(`../features/${dealreview}/pages/legal-pending/LegalQuestionnaire`)  // Also used in Overview
);
const LazyDealReviewStart = lazy(() =>
	import(`../features/${dealreview}/pages/in-progress`)  // Also used in Overview
);

const LazyDealReviewNewVersion = lazy(() =>
	import(`../features/${dealreview}/pages/new-version`)  // Also used in Overview
);

// Legal review

// const LazyLegalOverview = lazy(() => 
// 	import("../screens/legal/legaloverview")  // Also used in Overview
// );
const LazyLegalOverview = lazy(() => 
	import(`../features/${legal}/pages/new`)  // Also used in Overview
);
const LazySOWGenReviewMain = lazy(() =>
	import(`../features/${legal}/pages/review`)  // Also used in Overview
);
const LazyLegalInProcess = lazy(() =>
	import(`../features/${legal}/pages/in-proccess-complete`)  // Also used in Overview
);
const LazyLegalCompleted = lazy(() =>
	import(`../features/${legal}/pages/in-proccess-complete`)  // Also used in Overview
);
// const LazyLegDashboard = lazy(() =>
// 	import("../screens/legal/NewLegalDashboard")
// );
const LazyLegDashboard = lazy(() =>
	import(`../features/${legal}/pages/dashboard`)
);
const LazySOWGenAndUpload = lazy(() => 
	import(`../screens/${legal}/legalDashboard`)  // Also used in Overview
);
const LazyGenerateSOW = lazy(() => 
	import(`../screens/${legal}/legalDashboard`)  // Also used in Overview
);

// Resource Management -Dashboard

const LazyRMDashboard = lazy(() => 
	import("../features/resource-management/dashboard")
);

// Resource Management - People

//new rm-people
const LazyPeople = lazy(() => 
    import("../features/people/index")
)
//Profile

const LazyEmployeeProfile = lazy(() => 
	import("../features/my-profile")
);

// Add employee

const LazyRMAddEmployee = lazy(() => import("../features/add-employee"))

// Resource Management - Projects

const LazyProjectsOverview = lazy(() =>
	import(`../features/${project}/pages/upcomming-active-complete`)
);
const LazyProjectsDashboard = lazy(() => 
	import(`../features/${project}/pages/dashboard`)
);

//Reports Generation
const LazyBenchForcasting = lazy(() => import ("../features/report/pages/bench-projection/index"))
const LazyRMSheet = lazy(() => import ("../features/resource-management/rm-sheet/index"))
const LazyDemandResources = lazy(() => import ("../features/resource-management/demand-pipeline"))
const LazyGlobalAvailability = lazy(() => import ("../features/report/pages/global-availability/pages/index"));
const LazyYTDSummaryReport = lazy(() => import ("../features/report/pages/ytd/index"))
// Resource Management - Resource Request

const LazyDemandPipelineDashboard = lazy(() =>
	import("@features/resource-management/resource-request/index")
);
const LazyDemandPipeline = lazy(() =>
	import("@features/resource-management/resource-request/pages/preliminaryStaffing-demand/index")
);
const LazyProjectDemand = lazy(() =>
	import("@features/resource-management/resource-request/pages/project-demand/pages/index") 
);
const LazyOtherDemand = lazy(() =>
	import("@features/resource-management/resource-request/pages/other-demand/pages/index") 
);


// Resource Management - Resource Allocation


const LazyProjectHome = lazy(() =>
	import(`@resource-management/resource-allocation/pages/dashboard`)
);
const LazyResourceAllocationFact = lazy(() =>
	import("@resource-management/resource-allocation/pages/allocation-fact")  // Also used in Overview and INAB
);
const LazyINABRMProjectsOverview = lazy(() =>
	import("@features/components/CommonINABindex") // Also used in Overview, INAB, RM - Projects
);
const LazyResourceAllocationReview = lazy(() =>
	import('@resource-management/resource-allocation/pages/complete') // Also used in Overview and INAB
);
const LazyResourceAllocation = lazy(() =>
	import(`@resource-management/resource-allocation/pages/new`)  // Also used in Overview
);


// Admin - User Management

const LazyAdminDashboard = lazy(() =>
	import("@features/admin/user-management/pages/dashboard")
);

// Admin - Notification

const LazySettings = lazy(() =>
	import("../features/admin/notification")
);

// Admin - Access Policy

const LazyAddAccessPolicy = lazy(() =>
	import("@features/admin/access-policy/pages/new-edit-policy")
);

const LazyAdminRBAC = lazy(() =>
	import("@features/admin/access-policy/pages/dashboard")
);

// Admin - Rate Card

const LazyAdminRBACRateCard = lazy(() =>
	import("@features/admin/rate-card/pages/dashboard")
);

// Admin - skills/certification

const LazyAdminSkillsAndCertifications = lazy(() => 
	// import("../screens/admin/skillsAndCertification")
	import("../features/admin/skills-certificate")
);

// Admin - Feedback
const LazyAdminFeedback = lazy(() =>
	import("../features/admin/feedback")
);
	
//PlaygroundC:/screens/INAB/reviewandapproval

const LazyPlayground = lazy(() => 
import(`../features/${playground}/worksheets`)
)

const LazyPlaygroundCurrentWorkingWorksheet = lazy(() =>
import(`../features/${playground}/current-worksheet`)
)

// deal review inprogress deal pages
const OverviewRedirect = () => (
	<Navigate to="overview" replace />
)
const OverviewTabForInprogress = lazy(() => import(`../features/${dealreview}/pages/in-progress/tabs/overview`));
const DealStaffingForInprogress = lazy(() => import(`../features/${dealreview}/pages/in-progress/tabs/Staffing/Staffing`));
const DrReviewTabForInprogress = lazy(() => import(`../features/${dealreview}/pages/in-progress/tabs/Review`));

const OverviewTabForVersion = lazy(() => import(`../features/${dealreview}/pages/new-version/tabs/overview`));
const DealStaffingForVersion = lazy(() => import(`../features/${dealreview}/pages/new-version/tabs/Staffing/Staffing`));
const DrReviewTabForVersion = lazy(() => import(`../features/${dealreview}/pages/new-version/tabs/Review`));

const LazyNotFound = lazy(() => import("../screens/NotFound"));

const OldPeople = () => {
  const { currentTab } = useParams();

  return (
    <Navigate
      to={`${PageConfig["RM"].PEOPLELANDING}/${currentTab}`}
      replace
    />
  );
};

const OldProfile = () => {
  const { employeeid } = useParams();

  return (
    <Navigate
      to={`${PageConfig["RM"].PROFILE}/${employeeid}`}
      replace
    />
  );
};

const OldRmSheet = () => {
  return (
    <Navigate
      to={`${PageConfig["RG"].RGRMSheet}`}
      replace
    />
  );
};

const OldRmSheetProfile = () => {
  const { employeeid } = useParams();

  return (
    <Navigate
      to={`${PageConfig["RG"].RGRMSHEETPROFILE}/${employeeid}`}
      replace
    />
  );
};

const OldDemandPipeline = () => {
  const { currentTab } = useParams();

  return (
    <Navigate
      to={`${PageConfig["RM"].DEMANDPIPELINE}/${currentTab}`}
      replace
    />
  );
};
const OldProjectDemand = () => {
  const { dealstatus, currentTab, projectid, demandid } = useParams();
  const location = useLocation();

  return (
    <Navigate
      to={`${PageConfig["RM"].PROJECTDEMAND}/${dealstatus}/${currentTab}/${projectid}/${demandid}${location.search}`}
      replace
    />
  );
};

const OldOtherDemand = () => {
  const { dealstatus, projectid } = useParams();
  const location = useLocation();

  return (
    <Navigate
      to={`${PageConfig["RM"].OTHERDEMAND}/${dealstatus}/${projectid}${location.search}`}
      replace
    />
  );
};
const OldDemandForecast = () => {
  return (
    <Navigate
      to={`${PageConfig["RG"].RGDemandResources}`}
      replace
    />
  );
};
const OldDemandForecastProfile = () => {
  const { employeeid } = useParams();

  return (
    <Navigate
      to={`${PageConfig["RG"].RGDemandResourcesPROFILE}/${employeeid}`}
      replace
    />
  );
};

const joinPath = (...parts) =>
  parts
    .map(p => p.replace(/^\/|\/$/g, "")) // remove leading/trailing slashes
    .filter(Boolean)
    .join("/")
    .replace(/^/, "/"); // ensure leading slash

export const privateRoutes = [
	// Scoped Deals
	// {
	// 	id: 3,
	// 	path: `${PageConfig["PRELIMINARY"].DASHBOARD}/:currentTab`,
	// 	component: LazyPreliminaryStaffingDashboard,
	// 	Permissions: ["scopeddeals_view"],
	// },
	// {
	// 	id: 4,
	// 	path: `/:module${PageConfig["PRELIMINARY"].REVIEW}/:dealstatus/:projectid`,
	// 	component: LazyPreliminaryStaffingReview,
	// 	Permissions: ["scopeddeals_view"],
	// },
	// {
	// 	id: 40,
	// 	path: `/:module${PageConfig["PRELIMINARY"].OVERVIEW}/:dealstatus/:projectid`,
	// 	component: LazyPreliminaryStaffingOverview,
	// 	Permissions: ["scopeddeals_view"],
	// },	
		// Scoped - RM -Overview
	// {
	// 	id: 41,
	// 	path: `/:module${PageConfig["RM"].PRELIMINARY}/:dealstatus/:projectid`,
	// 	component: LazyPreliminaryStaffingOverview,
	// 	Permissions: ["rm_resource_allocation_view"],
	// },

	// INAB
	{
		id: 29,
		path: `/:module${PageConfig["RM"].INABPROJECTSOVERVIEW}/:dealstatus/:inapnum`,
		component: LazyINABRMProjectsOverview,
		Permissions: ["inab_view"],
	},
	{
		id: 5,
		path: `${PageConfig["INAB"].DASHBOARD}/:currentTab`,
		component: LazyINABDashboard,
		Permissions: ["inab_view"],
	},
	{
		id: 6,
		path: `${PageConfig["INAB"].NEWSUBMISSION}`,
		component: LazyINABNewSubmission,
		Permissions: ["inab_view"],
	},
	{
		id: 7,
		path: `/:module${PageConfig["INAB"].PLAINREVIEWANDAPPROVAL}/:dealstatus/:inapnum`,
		component: LazyINABReviewAndApproval,
		Permissions: ["inab_view"],
	},
	{
		id: 8,
		path: `/:module${PageConfig["INAB"].PLAINSUBMITFORRM}/:dealstatus/:inapnum`,         
		component: LazyINABSubmitForRm,
		Permissions: ["inab_view"],
	},

	// Deal Review
	{
		id: 9,
		path: `${PageConfig["DEALS"].DEALREVIEWDASHBOARD}/:currentTab`,
		component: LazyDrDashboard,
		Permissions: ["dealreview_view"],
	},
	{
		id: 10,
		path: `/:module${PageConfig["DEALS"].DEALREVIEW}/:dealstatus/:projectid`,
		component: LazyDealReviewStart,
		Permissions: ["dealreview_view"],
		children: [
			{
				index	: true, // default tab
				component: OverviewRedirect, // renders inside <Outlet />
			},
			{
				path: "overview", // nested tab route
				component: OverviewTabForInprogress, // renders inside <Outlet />
				Permissions: ["dealreview_view"],
			},
			{
				path: "staffing", // nested tab route
				component: DealStaffingForInprogress, // renders inside <Outlet />
				Permissions: ["dealreview_view"],
			},
			{
				path: "review", // nested tab route
				component: DrReviewTabForInprogress, // renders inside <Outlet />
				Permissions: ["dealreview_view"],
			},
		],
	},
	{
		id: 62,
		path: `/:module${PageConfig["DEALS"].VERSIONCREATION}/:dealstatus/:projectid`,
		component: LazyDealReviewNewVersion,
		Permissions: ["dealreview_view"],
		children: [
			{
				index	: true, // default tab
				component: OverviewRedirect, // renders inside <Outlet />
			},
			{
				path: "overview", // nested tab route
				component: OverviewTabForVersion, // renders inside <Outlet />
				Permissions: ["dealreview_view"],
			},
			{
				path: "staffing", // nested tab route
				component: DealStaffingForVersion, // renders inside <Outlet />
				Permissions: ["dealreview_view"],
			},
			{
				path: "review", // nested tab route
				component: DrReviewTabForVersion, // renders inside <Outlet />
				Permissions: ["dealreview_view"],
			},
		],
	},
	{
		id: 11,
		path: `/:module${PageConfig["DEALS"].REVIEWANDAPPROVAL}/:dealstatus/:projectid`,
		component: LazyReviewAndApproval,
		Permissions: ["dealreview_view"],
	},
		{
		id: 12,
		path: `/:module${PageConfig["DEALS"].OVERVIEWPROJECT}/:dealstatus/:currentTab/:projectid`,
		component: LazyOverviewNewDeal,
		Permissions: ["dealreview_view"],
	},
	{
		id: 13,
		path: `/:module${PageConfig["DEALS"].LEGALQUESTIONNAIRE}/:dealstatus/:projectid`,
		component: LazyLegalQuestionnaire,
		Permissions: ["dealreview_view"],
	},
	{
		id: 57,
		path: `/:module${PageConfig["DEALREVIEW"].DR_DEAL_LOST}/:dealstatus/:projectid`,
		component: LazyCompleteAndDealLost,
		Permissions: ["dealreview_view"],
	},
		{
		id: 57,
		path: `/:module${PageConfig["DEALREVIEW"].DR_COMPLETE}/:dealstatus/:projectid`,
		component: LazyCompleteAndDealLost,
		Permissions: ["dealreview_view"],
	},


	
	// Legal Review

	{
		id: 14,
		path: `${PageConfig["LEGAL"].LEGAL_DASHBOARD}/:currentTab`,
		component: LazyLegDashboard,
		Permissions: ["legalreview_view"],
	},
	{
		id: 15,
		path: `/:module${PageConfig["LEGAL"].OVERVIEWPROJECT}/:dealstatus/:currentTab/:projectid`,
		component: LazyLegalOverview,
		Permissions: ["legalreview_view"],
	},
	{
		id: 16,
		path: `/:module${PageConfig["LEGAL"].SOWGENERATE}/:dealstatus/:currentTab/:projectid`,
		component: LazyGenerateSOW,
		Permissions: ["legalreview_view"],
	},
	{
		id: 17,
		path: `/:module${PageConfig["LEGAL"].SOWUPLOAD}/:dealstatus/:projectid`,
		component: LazySOWGenAndUpload,
		Permissions: ["legalreview_view"],
	},
	{
		id: 18,
		path: `/:module${PageConfig["LEGAL"].FINALREVIEW}/:dealstatus/:projectid`,
		component: LazySOWGenReviewMain,
		Permissions: ["legalreview_view"],
	},
	{
		id: 51,
		path: `/:module${PageConfig["LEGAL"].INPROCESS}/:dealstatus/:projectid`,
		component: LazyLegalInProcess,
		Permissions: ["legalreview_view"],
	},
	{
		id: 51,
		path: `/:module${PageConfig["LEGAL"].LEGALCOMPLETE}/:dealstatus/:projectid`,
		component: LazyLegalCompleted,
		Permissions: ["legalreview_view"],
	},
	{
		id: 56,
		path: `/:module${PageConfig["LEGAL"].LEG_DEAL_LOST}/:dealstatus/:projectid`,
		component: LazyLegalCompleted,
		Permissions: ["legalreview_view"],
	},

	// Resource Management -Dashboard

	{
		id: 19,
		path: `${PageConfig["RM"].RMDASHBOARD}`,
		component: LazyRMDashboard,
		Permissions: ["rm_dashboard_view"],
	},
	
	// Resource Management - People

	{
		id: 20,
		path: `${PageConfig["RM"].PEOPLELANDING}/:currentTab`,
		// component: LazyRMPeopleLanding,
		component: LazyPeople,
		Permissions: ["people_list_view"],
	},
	{
		id: 64,
		path: `${PageConfig["RM"].OLD_PEOPLELANDING}/:currentTab`,
		component: OldPeople ,
		Permissions: ["people_list_view"],
	},
	{
		id: 21,
		path: `${PageConfig["RM"].PROFILE}/:employeeid`,
		// component: LazyProfile,
		component: LazyEmployeeProfile,
		Permissions: ["people_list_view"]
	},
	{
		id: 67,
		path: `${PageConfig["RM"].OLD_PROFILE}/:employeeid`,
		// component: LazyProfile,
		component: OldProfile,
		Permissions: ["people_list_view"]
	},
	{
		id: 52,
		path: `${MY_PROFILE_PATH}`,
		// component: LazyProfile,
		component: LazyEmployeeProfile,
		Permissions: ["my_profile_view"],
	},
	
	// Resource Management - Projects

	{
		id: 49,
		path: `${PROJECTS}${PageConfig["RM"].INABPROJECTSOVERVIEW}/:dealstatus/:inapnum`,
		component: LazyINABRMProjectsOverview,
		Permissions: ["rm_project_view"],
	},
	{
		id: 22,
		path: `${PROJECTS}${PageConfig["RM"].PRoJECTSOVERVIEW}/:dealstatus/:currentTab/:projectid`,
		component: LazyProjectsOverview,
		Permissions: ["rm_project_view"],
	},
	{
		id: 23,
		path: `${PROJECTS}/:currentTab`,
		component: LazyProjectsDashboard,
		Permissions: ["rm_project_view"],
	},

	// Resource Management - Resource Request

	{
        id: 24,
        path: `${PageConfig["RM"].DEMANDPIPELINE}/:currentTab`,
        component: LazyDemandPipelineDashboard,
        Permissions: ["rm_resource_request_view"],
    },
	{
        id: 68,
        path: `${PageConfig["RM"].OLD_DEMANDPIPELINE}/:currentTab`,
        component: OldDemandPipeline,
        Permissions: ["rm_resource_request_view"],
    },
	// {
	// 	id: 25,
	// 	path: `${PageConfig["RM"].PRELIMINARYSTAFFINGDEMAND}/:dealstatus/:currentTab/:projectid/:demandid`,
    //     component: LazyDemandPipeline,
    //     Permissions: ["rm_demand_pipeline_view"],
    // },

	//Project Demand
	{
		id: 58,
        path: `${PageConfig["RM"].PROJECTDEMAND}/:dealstatus/:currentTab/:projectid/:demandid`,
        component: LazyProjectDemand,
        Permissions: ["rm_resource_request_view"],	
	},
	//Project Demand
	{
		id: 69,
        path: `${PageConfig["RM"].OLD_PROJECTDEMAND}/:dealstatus/:currentTab/:projectid/:demandid`,
        component: OldProjectDemand,
        Permissions: ["rm_resource_request_view"],	
	},

	//Other Demand
		{
		id: 59,
        path: `${PageConfig["RM"].OTHERDEMAND}/:dealstatus/:projectid`,
        component: LazyOtherDemand,
        Permissions: ["rm_resource_request_view"],	
	},
	//Other Demand
		{
		id: 70,
        path: `${PageConfig["RM"].OLD_OTHERDEMAND}/:dealstatus/:projectid`,
        component: OldOtherDemand,
        Permissions: ["rm_resource_request_view"],	
	},

	//Reports Generation
	{
        id: 52,
        path: `${PageConfig["RG"].RGBench}/:currentTab`,
        component: LazyBenchForcasting,
        Permissions: ["report_generation_view"],
    },
	{
        id: 53,
        path: `${PageConfig["RG"].RGRMSheet}`,
        component: LazyRMSheet,
        Permissions: ["rm_rmsheet_view"],
    },
	{
        id: 66,
        path: `${PageConfig["RG"].OLD_RGRMSheet}`,
        component: OldRmSheet,
        Permissions: ["rm_rmsheet_view"],
    },
	{
        id: 56,
        path: `${PageConfig["RG"].RGDemandResources}`,
        component: LazyDemandResources,
        Permissions: ["rm_demand_pipeline_view"],
    },
	{
        id: 80,
        path: `${PageConfig["RG"].OLD_RGDemandResources}`,
        component: OldDemandForecast,
        Permissions: ["rm_demand_pipeline_view"],
    },
	{
        id: 57,
        path: `${PageConfig["RG"].RGDemandResourcesPROFILE}/:employeeid`,
        component: LazyEmployeeProfile,
        Permissions: ["rm_demand_pipeline_view"],
    },
	{
        id: 81,
        path: `${PageConfig["RG"].OLD_RGDemandResourcesPROFILE}/:employeeid`,
        component: OldDemandForecastProfile,
        Permissions: ["rm_demand_pipeline_view"],
    },
	{
		id: 54,
		path: `${PageConfig["RG"].RGBENCHPROFILE}/:employeeid`,
		component: LazyEmployeeProfile,
		Permissions: ["report_generation_view"],
	},
	{
		id: 55,
		path: `${PageConfig["RG"].RGRMSHEETPROFILE}/:employeeid`,
		component: LazyEmployeeProfile,
		Permissions: ["rm_rmsheet_view", "rm_rmsheet_edit"],
	},
	{
		id: 65,
		path: `${PageConfig["RG"].OLD_RGRMSHEETPROFILE}/:employeeid`,
		component: OldRmSheetProfile,
		Permissions: ["rm_rmsheet_view", "rm_rmsheet_edit"],
	},
	{
		id: 60,
		path: `${PageConfig["RG"].RGGlobalAvailability}/:currentTab`,
		component: LazyGlobalAvailability,
		Permissions: ["report_generation_view"],
	},
	{
		id: 61,
		path: `${PageConfig["RG"].RGGlobalAvailabilityBenchManagement}/:currentTab`,
		component: LazyGlobalAvailability,
		Permissions: ["report_generation_view"],
	},
	{
		id: 63,
		path: `${PageConfig["RG"].RGGlobalAvailabilityYTDSummaryReport}`,
		component: LazyYTDSummaryReport,
		Permissions: ["report_generation_view"],
	},

	// Resource Management - Resource Allocation

	{
		id: 26,
		path: `${PageConfig["RM"].PROJECTHOME}/:currentTab`,
		component: LazyProjectHome,
		Permissions: ["rm_resource_allocation_view"],
	},
	// {
    //     id: 51,
    //     path: `${PageConfig["RM"].RMLANDING}/rmsheet`,
    //     component: RMSheet,
    //     Permissions: ["rm_people_list_view","rm_employee_profile_view"],
    // },
	{
		id: 27,
		path: `/:module${PageConfig["RM"].RESOURCEALLOCTIONFACT}/:dealstatus/:projectid/:demandid`,
		component: LazyResourceAllocationFact,
		Permissions: ["rm_resource_allocation_view"],
	},
	{
		id: 28,
		path: `/:module${PageConfig["RM"].INABRESOURCEALLOCTIONFACT}/:dealstatus/:inapnum`,
		component: LazyResourceAllocationFact,
		Permissions: ["rm_resource_allocation_view"],
	},
		{
		id: 30,
		path: `/:module${PageConfig["RM"].INABALLOCATON}/:dealstatus/:inapnum`,
		component: LazyINABRMProjectsOverview,
		Permissions: ["rm_resource_allocation_view","WRITE"],
	},
	{
		id: 53,
		path: `/:module${PageConfig["RM"].RESOURCEALLOCTIONFACTPARTIALALLOCATION}/:dealstatus/:projectid/:demandid`,
		component: LazyResourceAllocationFact,
		Permissions: ["rm_resource_allocation_view"],
	},
	{
		id: 31,
		path: `/:module${PageConfig["RM"].RESOURCEALLOCTIONFACTREVIEW}/:dealstatus/:projectid/:demandid`,
		component: LazyResourceAllocationReview,
		Permissions: ["rm_resource_allocation_view"],
	},
	{
		id: 32,
		path: `/:module${PageConfig["RM"].INABRESOURCEALLOCTIONFACTREVIEW}/:dealstatus/:inapnum`,
		component: LazyResourceAllocationReview,
		Permissions: ["rm_resource_allocation_view"],
	},
	{
		id: 33,
		path: `/:module${PageConfig["RM"].RESOURCEALLOCTION}/:dealstatus/:projectid/:demandid`,
		component: LazyResourceAllocation,
		Permissions: ["rm_resource_allocation_view"],
	},

	
	// Admin - User Management

	{
		id: 34,
		path: `${PageConfig["ADMIN"].DASHBOARD}/:currentTab`,
		component: LazyAdminDashboard,
		Permissions: ["admin_usermanagement_view"],
	},

	// Admin - Notification

	{
		id: 35,
		path: `${PageConfig["ADMIN"].NOTIFICATION}`,
		component: LazySettings,
        Permissions: ["notification_view"],
	},

	// Admin - Access Policy
	
	{
		id: 36,
		path: `${PageConfig["ADMIN"].RBAC}/create-access-policy`,
		component: LazyAddAccessPolicy,
        Permissions: ["admin_accesspolicy_view"],
	},
	{
		id: 37,
		path: `${PageConfig["ADMIN"].RBAC}/edit-access-policy/:policyId`,
		component: LazyAddAccessPolicy,
		Permissions: ["admin_accesspolicy_view"],
	},
	{
		id: 38,
		path: `${PageConfig["ADMIN"].RBAC}`,
		component: LazyAdminRBAC,
        Permissions: ["admin_accesspolicy_view"],
	},
	
	// Admin - Rate Card

	{
		id: 39,
		path: `${PageConfig["ADMIN"].RBACRATECARD}`,
		component: LazyAdminRBACRateCard,
        Permissions: ["admin_ratecard_view"],
	},
    
	// Admin - skills And Certification

	{
		id: 46,
		path: `${PageConfig["ADMIN"].SKILLSANDCERTIFICATION}`,
		component: LazyAdminSkillsAndCertifications,
        Permissions: ["admin_skillscertification_view"],
	},

	// Admin - Feedback

 	{
		id: 82,
		path: `${PageConfig["ADMIN"].FEEDBACK}`,
		component: LazyAdminFeedback,
        Permissions: ["admin_feedback_view"],
	},


	// Playground
  {
        id: 47,
        path: `${PageConfig["PLAYGROUND"].WORKSHEETS}/:projectId`,
        component: LazyPlayground,
        Permissions: ["playground_view_edit"],
    },
    {
        id: 48,
        path: `${PageConfig["PLAYGROUND"].CURRENTWORKINGWORKSHEET}/:projectId/:sheetId/:currentTab`,
        component: LazyPlaygroundCurrentWorkingWorksheet,
        Permissions: ["playground_view_edit"],
    },
    {
        id: 50,
        path: `${PageConfig["PLAYGROUND"].PROJECTS}`,
        component: LazyPlaygroundProjects,
        Permissions: ["playground_view_edit"],
    },

	// Add Employee

	{
		id: 63,
		path: `${PageConfig["RM"].PEOPLELANDING}${PageConfig["RM"].ADDEMPLOYEE}`,
		component: LazyRMAddEmployee,
		Permissions: ["people_list_view"],
	},
	{
		id: 64,
		path: `${PageConfig["RG"].RGRMSheet}${PageConfig["RM"].ADDEMPLOYEE}`,
		component: LazyRMAddEmployee,
		Permissions: ["rm_rmsheet_view"],
	},

	// Un Used Private Routes
	// {
	// 	id: 42,
	// 	path: "/deal-review-dashboard/all-deal-review",
	// 	component: LazyAllDealReview,
	// 	Permissions: ["READ", "user"],
	// },
	// {
	// 	id: 43,
	// 	path: "/legal-dashboard/all-legal-review",
	// 	component: LazyAllLegalReview,
	// 	Permissions: ["legal_access"],
	// },
	// {
	// 	id: 44,
	// 	path: `${PageConfig["RM"].ADDEMPLOYEE}`,
	// 	component: LazyRMAddEmployee,
	// 	Permissions: ["READ"],
	// },	
	// {
	// 	id: 45,
	// 	path: `${PageConfig["PROFILE"].MYPROFILE}/:employeeid`,
	// 	component: LazyProfileScreen,
	// 	Permissions: ["READ"],
	// },
];


// export const LazyComponents = {
// 	LazyHome: lazy(() => import("../screens/dashboard")),
// 	LazyAllDealReview: lazy(() =>
// 	  import("../screens/dealreview/allviewdeals/AllDealReview")
// 	),
// 	LazyDrDashboard: lazy(() =>
// 	  import("../screens/dealreview/dealreviewDashboard/index")
// 	),
// 	LazyAllLegalReview: lazy(() =>
// 	  import("../screens/legal/overview/AllLegalReview")
// 	),
// 	LazyLegalQuestionnaire: lazy(() =>
// 	  import("../screens/legal/LegalQuestionnaire/LegalQuestionnaire")
// 	),
// 	LazyOverviewNewDeal: lazy(() =>
// 	  import("../screens/dealreview/droverview")
// 	),
// 	LazyLegDashboard: lazy(() =>
// 	  import("../screens/legal/NewLegalDashboard")
// 	),
// 	LazyLegalOverview: lazy(() => import("../screens/legal/legaloverview")),
// 	LazyDealReviewStart: lazy(() =>
// 	  import("../screens/dealreview/dealreviewstart")
// 	),
// 	LazySOWGenAndUpload: lazy(() => import("../screens/legal/uploadsow")),
// 	LazySOWGenReviewMain: lazy(() =>
// 	  import("../screens/legal/CustomerReview")
// 	),
// 	LazyGenerateSOW: lazy(() => import("../screens/legal/generatesow")),
// 	LazyReviewAndApproval: lazy(() =>
// 	  import("../screens/dealreview/reviewandapproval")
// 	),
// 	LazyRMPeopleLanding: lazy(() =>
// 	  import("../screens/RM/people/peoplelanding")
// 	),
// 	LazyResourceAllocation: lazy(() =>
// 	  import("../screens/RM/resourceallocation/resourceallocation")
// 	),
// 	LazyProjectsDashboard: lazy(() => import("../screens/RM/projects")),
// 	LazyProjectHome: lazy(() =>
// 	  import("../screens/RM/resourceallocation/projecthome")
// 	),
// 	LazyRMDashboard: lazy(() => import("../screens/RM/dashboard")),
// 	LazyProfile: lazy(() => import("../screens/RM/people/peopleprofile")),
// 	LazyResourceAllocationFact: lazy(() =>
// 	  import("../screens/RM/resourceallocation/resourceallocationfact")
// 	),
// 	LazyResourceAllocationReview: lazy(() =>
// 		import("../screens/RM/resourceallocation/resourceallocationreview")
// 	),
// 	PreliminaryStaffingOverview: lazy(() =>
// 		import("../screens/preliminarystaffing/viewproject")
// 	),
// 	LazyPreliminaryStaffingReview: lazy(() =>
// 		import("../screens/preliminarystaffing/preliminationstaffingreview")
// 	),
// 	LazyPreliminaryStaffingDashboard: lazy(() =>
// 		import("../screens/preliminarystaffing/dashboard")
// 	),
// 	LazyINABDashboard: lazy(() => import("../screens/INAB/dashboard")),
// 	LazyINABReviewAndApproval: lazy(() =>
// 		import("../screens/INAB/reviewandapproval")
// 	),
// 	LazyINABNewSubmission: lazy(() =>
// 		import("../screens/INAB/reviewandapproval")
// 	),
// 	LazyINABSubmitForRm: lazy(() => import("../screens/INAB/reviewandapproval")),
// 	LazyProjectsOverview: lazy(() =>
// 		import("../screens/RM/projects/projectsoverview")
// 	),
// 	LazyINABRMProjectsOverview: lazy(() =>
// 		import("../screens/RM/projects/inaboveriew")
// 	),
// 	LazyRMAddEmployee: lazy(() =>
// 		import("../screens/RM/AddEmployee")
// 	),
// 	LazyAdminDashboard: lazy(() =>
// 		import("../screens/admin/dashboard")
// 	),
// 	LazySettings: lazy(() =>
// 		import("../screens/settings/notification")
// 	),
// 	LazyAddAccessPolicy: lazy(() =>
// 		import("../screens/admin/createAccessPolicy")
// 	),
// 	LazyAdminRBAC: lazy(() =>
// 		import("../screens/admin/RBAC")
// 	),
// 	LazyAdminRBACRateCard: lazy(() =>
// 		import("../screens/admin/RateCard")
// 	),
// 	LazyHistory: lazy(() => import("../screens/dashboard/history")),
// 	LazyDemandPipelineDashboard: lazy(() =>
// 		import("../screens/RM/demandpipeline/index")
// 	),
// 	LazyDemandPipeline: lazy(() =>
// 		import("../screens/RM/demandpipeline/tabs/index")
// 	),
// };


// export const routes = [
// 	{
// 		id: 1,
// 		path: `${PageConfig.DASHBOARD}/:currentTab`,
// 		component: "LazyHome",
// 		Permissions: ["READ", "user"],
// 	},
// 	{
// 		id: 2,
// 		path: `${PageConfig["DEALS"].DEALREVIEWDASHBOARD}/:currentTab`,
// 		component: "LazyDrDashboard",
// 		Permissions: ["READ", "user"],
// 	},
// 	{
// 		id: 3,
// 		path: `/:module${PageConfig["DEALS"].DEALREVIEW}/:dealstatus/:previousTab/:currentTab/:projectid`,
// 		component: "LazyDealReviewStart",
// 		Permissions: ["READ", "user"],
// 	},
// 	{
// 		id: 4,
// 		path: `/:module${PageConfig["DEALS"].REVIEWANDAPPROVAL}/:dealstatus/:projectid`,
// 		component: "LazyReviewAndApproval",
// 		Permissions: ["READ", "user"],
// 	},
// 	{
// 		id: 5,
// 		path: "/deal-review-dashboard/all-deal-review",
// 		component: "LazyAllDealReview",
// 		Permissions: ["READ", "user"],
// 	},
// 	{
// 		id: 6,
// 		path: `/:module${PageConfig["DEALS"].OVERVIEWPROJECT}/:dealstatus/:previousTab/:currentTab/:projectid`,
// 		component: "LazyOverviewNewDeal",
// 		Permissions: ["READ", "user"],
// 	},
// 	{
// 		id: 7,
// 		path: `${PageConfig["LEGAL"].LEGAL_DASHBOARD}/:currentTab`,
// 		component: "LazyLegDashboard",
// 		Permissions: ["legal_access"],
// 	},
// 	{
// 		id: 8,
// 		path: `/:module${PageConfig["LEGAL"].OVERVIEWPROJECT}/:dealstatus/:previousTab/:currentTab/:projectid`,
// 		component: "LazyLegalOverview",
// 		Permissions: ["legal_access"],
// 	},
// 	{
// 		id: 10,
// 		path: "/legal-dashboard/all-legal-review",
// 		component: "LazyAllLegalReview",
// 		Permissions: ["legal_access"],
// 	},
// 	{
// 		id: 11,
// 		path: `/:module${PageConfig["LEGAL"].SOWGENERATE}/:dealstatus/:previousTab/:currentTab/:projectid`,
// 		component: "LazyGenerateSOW",
// 		Permissions: ["generate_sow"],
// 	},
// 	{
// 		id: 12,
// 		path: `/:module${PageConfig["LEGAL"].SOWUPLOAD}/:dealstatus/:previousTab/:projectid`,
// 		component: "LazySOWGenAndUpload",
// 		Permissions: ["generate_sow"],
// 	},
// 	{
// 		id: 13,
// 		path: `/:module${PageConfig["LEGAL"].FINALREVIEW}/:dealstatus/:previousTab/:projectid`,
// 		component: "LazySOWGenReviewMain",
// 		Permissions: ["lg_customer_review"],
// 	},
// 	{
// 		id: 14,
// 		path: `/:module${PageConfig["DEALS"].LEGALQUESTIONNAIRE}/:dealstatus/:dealid`,
// 		component: "LazyLegalQuestionnaire",
// 		Permissions: ["READ"],
// 	},
// 	{
// 		id: 15,
// 		path: `${PageConfig["RM"].RMDASHBOARD}`,
// 		component: "LazyRMDashboard",
// 		Permissions: ["READ"],
// 	},
// 	{
// 		id: 16,
// 		path: `${PageConfig["RM"].PEOPLELANDING}/:currentTab`,
// 		component: "LazyRMPeopleLanding",
// 		Permissions: ["READ"],
// 	},
// 	{
// 		id: 16,
// 		path: `${PageConfig["RM"].PROJECTS}/:currentTab`,
// 		component: "LazyProjectsDashboard",
// 		Permissions: ["READ"],
// 	},

// 	{
// 		id: 17,
// 		path: `${PageConfig["RM"].PROJECTHOME}/:currentTab`,
// 		component: "LazyProjectHome",
// 		Permissions: ["READ"],
// 	},
// 	{
// 		id: 18,
// 		path: `/:module${PageConfig["RM"].RESOURCEALLOCTION}/:dealstatus/:projectid`,
// 		component: "LazyResourceAllocation",
// 		Permissions: ["READ"],
// 	},
// 	{
// 		id: 19,
// 		path: `/:module${PageConfig["RM"].RESOURCEALLOCTIONFACT}/:previousTab/:projectid`,
// 		component: "LazyResourceAllocationFact",
// 		Permissions: ["READ"],
// 	},
// 	{
// 		id: 20,
// 		path: `${PageConfig["RM"].PROFILE}/:dealstatus`,
// 		component: "LazyProfile",
// 		Permissions: ["READ"],
// 	},
// 	{
// 		id: 21,
// 		path: `/:module${PageConfig["RM"].RESOURCEALLOCTIONFACTREVIEW}/:dealstatus/:projectid`,
// 		component: "LazyResourceAllocationReview",
// 		Permissions: ["READ"],
// 	},
// 	{
// 		id: 22,
// 		path: `/:module${PageConfig["PRELIMINARY"].OVERVIEW}/:dealstatus/:projectid`,
// 		component: "PreliminaryStaffingOverview",
// 		Permissions: ["READ"],
// 	},
// 	{
// 		id: 23,
// 		path: `/:module${PageConfig["PRELIMINARY"].REVIEW}/:dealstatus/:projectid`,
// 		component: "LazyPreliminaryStaffingReview",
// 		Permissions: ["READ"],
// 	},
// 	{
// 		id: 24,
// 		path: `${PageConfig["PRELIMINARY"].DASHBOARD}`,
// 		component: "LazyPreliminaryStaffingDashboard",
// 		Permissions: ["READ"],
// 	},
// 	{
// 		id: 25,
// 		path: `${PageConfig["INAB"].DASHBOARD}/:currentTab`,
// 		component: "LazyINABDashboard",
// 	},
// 	{
// 		id: 26,
// 		path: `${PageConfig["RM"].PRoJECTSOVERVIEW}/:dealstatus/:previousTab/:currentTab/:projectid`,
// 		component: "LazyProjectsOverview",
// 		Permissions: ["READ","WRITE"],
// 	},
// 	{
// 		id: 27,
// 		path: `${PageConfig["INAB"].REVIEWANDAPPROVAL}/:dealstatus/:inapnum`,
// 		component: "LazyINABReviewAndApproval",
// 		Permissions: ["READ"],
// 	},
// 	{
// 		id: 28,
// 		path: `${PageConfig["INAB"].SUBMITFORRM}/:dealstatus/:inapnum`,
// 		component: "LazyINABSubmitForRm",
// 		Permissions: ["READ"],
// 	},
// 	{
// 		id: 29,
// 		path: `${PageConfig["INAB"].NEWSUBMISSION}`,
// 		component: "LazyINABNewSubmission",
// 		Permissions: ["READ"],
// 	},
// 	{
// 		id: 30,
// 		path: `${PageConfig["RM"].INABPROJECTSOVERVIEW}/:dealstatus/:inapnum`,
// 		component: "LazyINABRMProjectsOverview",
// 		Permissions: ["READ","WRITE"],
// 	},
// 	{
// 		id: 31,
// 		path: `/:module${PageConfig["RM"].INABALLOCATON}/:inapnum`,
// 		component: "LazyINABRMProjectsOverview",
// 		Permissions: ["READ","WRITE"],
// 	},
// 	{
// 		id: 32,
// 		path: `/:module${PageConfig["RM"].INABRESOURCEALLOCTIONFACT}/:dealstatus/:inapnum`,
// 		component: "LazyResourceAllocationFact",
// 		Permissions: ["READ"],
// 	},
// 	{
// 		id: 33,
// 		path: `/:module${PageConfig["RM"].INABRESOURCEALLOCTIONFACTREVIEW}/:dealstatus/:inapnum`,
// 		component: "LazyResourceAllocationReview",
// 		Permissions: ["READ"],
// 	},
// 	{
// 		id: 34,
// 		path: `${PageConfig["RM"].ADDEMPLOYEE}`,
// 		component: "LazyRMAddEmployee",
// 		Permissions: ["READ"],
// 	},
// 	{
// 		id: 35,
// 		path: `/:module${PageConfig["RM"].PRELIMINARY}/:dealstatus/:projectid`,
// 		component: "PreliminaryStaffingOverview",
// 		Permissions: ["READ"],
// 	},
// 	{
// 		id: 36,
// 		path: "/admin/:currentTab",
// 		component: "LazyAdminDashboard",
// 		Permissions: ["READ"],
// 	},
// 	{
// 		id: 37,
// 		path: "/settings/notification",
// 		component: "LazySettings",
//         Permissions: ["READ","WRITE"],
// 	},
// 	{
// 		id: 38,
// 		path: "/admin/create-access-policy",
// 		component: "LazyAddAccessPolicy",
//         Permissions: ["READ","WRITE"],
// 	},
// 	{
// 		id: 39,
// 		path: "/admin/annotation",
// 		component: "LazyAdminRBAC",
//         Permissions: ["READ","WRITE"],
// 	},
// 	{
// 		id: 40,
// 		path: "/admin/ratecard",
// 		component: "LazyAdminRBACRateCard",
//         Permissions: ["READ","WRITE"],
// 	},
// 	{
// 		id: 41,
// 		path: "/admin/edit-access-policy/:policyId",
// 		component: "LazyAddAccessPolicy",
//         Permissions: ["READ","WRITE"],
//     },
// 	{
//         id: 42,
//         path: `/:module${PageConfig.DEAL_LOST}/:dealstatus/:projectid`,
// 		component: "LazyHistory",
// 		Permissions: ["READ", "WRITE"]
//     },
// 	{
// 		id: 43,
// 		path: `${PageConfig["RM"].DEMANDPIPELINE}/:currentTab`,
// 		component: "LazyDemandPipelineDashboard",
// 		Permissions: ["READ","WRITE"],
// 	},
// 	{
// 		id: 44,
// 		path: `${PageConfig["RM"].DEMANDPIPELINE}/:currentTab`,
// 		component: "LazyDemandPipeline",	
// 		Permissions: ["READ","WRITE"],
// 	}
// ];